import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'utils/with-i18next';

const EmptyChannel = props => {
  const t = props.t;

  return (
    <div className="myChannel-empty">
      <h2>{t('EmptyChannel.h2')}</h2>
      <p className="whiteSpace-pre">{t('EmptyChannel.p')}</p>
      <button id="creat-c" className="btn btn-small" onClick={() => props.setStatePopUp(true)}>
        {t('createChannel')}
      </button>
    </div>
  );
};

EmptyChannel.propTypes = {
  t: PropTypes.func,
};

export default withTranslation('myChannel')(EmptyChannel);
